import { render, staticRenderFns } from "./AreaReference.vue?vue&type=template&id=862595c6&scoped=true"
import script from "./AreaReference.vue?vue&type=script&lang=js"
export * from "./AreaReference.vue?vue&type=script&lang=js"
import style0 from "./AreaReference.vue?vue&type=style&index=0&id=862595c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862595c6",
  null
  
)

export default component.exports